import SeasonalOfferCarousel, { type SeasonalOfferCarouselProps } from './SeasonalOfferCarousel'

export default function LongWeekendOfferCarousel(props: SeasonalOfferCarouselProps) {
  return <SeasonalOfferCarousel {...props} category="longweekend" />
}
